// Global Instructions Rule Applied!

import { EmailCampaignsState, EmailCampaignsAction } from '../../interfaces/email.ts'
import { EmailCampaignGridModelFields } from '../../data_models/email_campaign_grid_model.ts'
import {
  SET_CAMPAIGNS,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  ADD_CAMPAIGN,
  UPDATE_CAMPAIGN_RECORD,
  REMOVE_CAMPAIGN
} from './constants.ts'

const emailCampaignsReducer = (
  state: EmailCampaignsState = {
    activeFilters: [],
    activeSorting: [],
    data: [],
    hasMore: false,
    currentPage: 1
  },
  action: EmailCampaignsAction
): EmailCampaignsState => {
  switch (action.type) {
    case SET_CAMPAIGNS: {
      const { response } = (
        action as { payload: { response: { data: any[]; hasMore: boolean } } }
      ).payload
      return {
        ...state,
        data: response.data,
        hasMore: response.hasMore,
        currentPage: 1
      }
    }

    case SET_ACTIVE_FILTERS: {
      const { filters } = (action as { payload: { filters: any[] } }).payload
      return { ...state, activeFilters: filters }
    }

    case SET_ACTIVE_SORTING: {
      const { sorting } = (action as { payload: { sorting: any[] } }).payload
      return { ...state, activeSorting: sorting }
    }

    case CLEAR_ACTIVE_FILTERS: {
      return { ...state, activeFilters: [] }
    }

    case ADD_CAMPAIGN: {
      const { campaign } = (action as { payload: { campaign: any } }).payload
      return { ...state, data: [campaign, ...state.data] }
    }

    case UPDATE_CAMPAIGN_RECORD: {
      const { campaignId, updates } = (
        action as { payload: { campaignId: string; updates: Record<string, any> } }
      ).payload
      const idKey = EmailCampaignGridModelFields.email_campaigns__id
      return {
        ...state,
        data: state.data.map((c) =>
          (c as any)[idKey] === campaignId ? { ...c, ...updates } : c
        )
      }
    }

    case REMOVE_CAMPAIGN: {
      const { campaignId } = (action as { payload: { campaignId: string } }).payload
      const idKey = EmailCampaignGridModelFields.email_campaigns__id
      return {
        ...state,
        data: state.data.filter((c) => (c as any)[idKey] !== campaignId)
      }
    }

    default:
      return state
  }
}

export default emailCampaignsReducer
export * from './email_actions.ts'
